import { Box, Container, Typography } from "@mui/material";
import { requestGetAll } from "../API/request_server";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import Heading from "./Heading";
export default function Message() {
  const [_messagesData, _setMessagesData] = useState([]);

  const getData = async () => {
    try {
      const result = await requestGetAll("messages/getall");

      const data = result.data.map((item) => ({
        id: item.message_id,
        message_title: item.message_title,
        message: item.message,
        image: item.image,
      }));

      _setMessagesData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Box>
        <Container>
          <Heading _title="Messages" />
          <Grid container spacing={3}>
            {_messagesData.map((item) => (
              <Grid size={{ xs: 12, md: 4 }}>
                <Grid container spacing={2} key={item.id}>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <Box textAlign="center">
                      <img
                        src={
                          item.image
                            ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
                            : //? `http://localhost/backend_ptp_admin/${item.image}`
                              "favicon.ico"
                        }
                        alt={item.message_title}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "12px",
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, md: 8 }} sx={{ p: 0.5 }}>
                    <Typography>{item.message_title}</Typography>

                    <Typography variant="body2" sx={{ fontSize: "14px" }}>
                      {item.message}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
